module.exports = __webpack_public_path__ + "img/联考平台@3x.a538f1c2.png";